import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    ${theme.layout.rowGap(4)}

    width: ${theme.layout.spacing(56)};
    max-width: 90vw;
    padding: ${theme.layout.spacing(6)};

    border-radius: 24px;

    background: ${theme.palette.neutral[50]};
    color: ${theme.palette.text.main};

    h2 {
      font-size: ${theme.typography.sizes.title2};
      font-weight: ${theme.typography.weight.bold};
    }

    p {
      font-size: ${theme.typography.sizes.body1};
      font-weight: ${theme.typography.weight.regular};
      white-space: pre-line;
    }

    button {
      width: 100%;
    }
  `}
`;

export const CheckboxRow = styled.label`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    ${theme.layout.columnGap(3)}

    cursor: pointer;

    span {
      font-size: ${theme.typography.sizes.body1};
      font-weight: ${theme.typography.weight.regular};
    }
  `}
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  ${({ theme }) => css`
    appearance: none;
    flex-shrink: 0;

    width: ${theme.layout.spacing(6)};
    height: ${theme.layout.spacing(6)};

    border: 2px solid ${theme.palette.neutral[400]};
    border-radius: 8px;

    background: ${theme.palette.neutral[0]};

    &:checked {
      border-color: ${theme.palette.primary.main};
      background: ${theme.palette.primary.main};
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3E%3Cpath d='M6.4 11.2 3.2 8l-1.2 1.2L6.4 13.6 14 6l-1.2-1.2z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center;
    }
  `}
`;

export const ErrorText = styled.p`
  ${({ theme }) => css`
    color: ${theme.palette.error.main};
  `}
`;
